import { FCC } from '@eluve/components';
import {
  useIsPromptTemplateCreator,
  useIsTemplatePublisher,
} from '@eluve/session-helpers';

export const TemplatesGuard: FCC = ({ children }) => {
  const isPromptTemplateCreator = useIsPromptTemplateCreator();
  const isTemplatePublisher = useIsTemplatePublisher();

  if (isPromptTemplateCreator || isTemplatePublisher) {
    return children;
  }

  return null;
};
